<script>
    import Picture from '$lib/components/Picture.svelte';

    export let content = [];
    export let modulePosition;
    export let sectionPosition;

    // Style
    let style = '';
    switch (content?.style) {
        case 'None':
            style = '';
            break;
        case 'Framed':
            style = 'rounded-xl border border-base-900/5 bg-base-900 px-4 text-center shadow-sm';
            break;
        default:
            style = 'rounded-xl border border-base-900/5 bg-base-900 px-4 text-center shadow-sm';
            break;
    }

    // Padding
    let padding = '';
    switch (content?.padding) {
        case 'Top & Bottom':
            padding = 'py-4 lg:py-8';
            break;
        case 'Top':
            padding = 'pb-0 pt-4 lg:pb-0 lg:pt-8';
            break;
        case 'Bottom':
            padding = 'pb-4 pt-0 lg:pb-8 lg:pt-0';
            break;
        case 'None':
            padding = 'p-0';
            break;
        default:
            padding = 'py-4 lg:py-8';
            break;
    }

    // Heading Size
    let headingSize = '';
    switch (content?.headingSize) {
        case 'Base':
            headingSize = 'text-base lg:text-lg';
            break;
        case 'XL':
            headingSize = 'text-xl';
            break;
        case '2XL':
            headingSize = 'text-xl lg:text-2xl';
            break;
        default:
            headingSize = 'text-base lg:text-lg';
            break;
    }

    // Mobile Layout
    let mobileLayout = '';
    let mobileGrid = '';
    switch (content?.layoutMobile) {
        case 'Grid':
            mobileLayout = 'grid grid-cols-2 gap-2';
            mobileGrid = 'flex-col';
            break;
        case 'List':
            mobileLayout = 'grid w-full gap-2';
            break;
        default:
            mobileLayout = '';
            break;
    }

    // Mobile Layout
    let dekstopLayout = '';
    let dekstopGrid = '';
    switch (content?.layoutDesktop) {
        case 'Grid':
            dekstopLayout = 'lg:flex lg:gap-4';
            dekstopGrid = 'lg:flex-col';
            break;
        case 'List':
            dekstopLayout = 'lg:flex lg:gap-4';
            break;
        default:
            dekstopLayout = '';
            break;
    }
</script>

<div class="{mobileLayout} {dekstopLayout} overflow-visible" data-moduleposition={modulePosition}>
    {#each content?.cards as card (card)}
        <div class="flex-1 {style} {padding}">
            <svelte:element this={card?.link?.url ? 'a' : 'div'} class="flex {mobileGrid} {dekstopGrid}" href={card?.link?.url} title={card?.link?.title}>
                <div>
                    {#if card?.image?.url}
                        <Picture
                            src={card?.image?.url}
                            alt={card?.image?.alt}
                            width={card?.image?.dimensions?.width}
                            height={card?.image?.dimensions?.height}
                            imageSizes={[200, 250, 300]}
                            lazy={sectionPosition && sectionPosition > 3}
                            classes={`${content?.layoutMobile === 'Grid' || content?.layoutDesktop === 'Grid' ? 'm-auto lg:w-48 w-34' : 'h-64 w-auto'}`}
                        />
                    {/if}
                </div>

                <div class="flex grow flex-col justify-center text-left">
                    {#if card?.title}
                        <svelte:element
                            this={content?.titleType}
                            class={`font-semibold ${headingSize} 
                            ${content?.layoutMobile === 'List' || content?.layoutDesktop === 'List' ? 'text-left' : 'text-center'}`}
                        >
                            {card?.title}
                        </svelte:element>
                    {/if}
                    {#if card?.body}
                        <p
                            class={`${
                                content?.layoutMobile === 'List' || content?.layoutDesktop === 'List'
                                    ? 'mt-2 text-left text-xs lg:block lg:text-base'
                                    : 'my-2 text-center text-xs lg:px-8 lg:text-base'
                            }`}
                        >
                            {card?.body}
                        </p>
                    {/if}
                </div>
            </svelte:element>
        </div>
    {/each}
</div>
